import type { AssetId, OutlookSpaceAssetId, TimeStreamAssets } from 'owa-timestream-types';
import getLocalAssetId from '../../assetId/getLocalAssetId';

export default function findAsset(assets: TimeStreamAssets, assetId: AssetId) {
    return assets.get(assetId) || assets.get(getLocalAssetId(assetId as OutlookSpaceAssetId)!);
}
